import { useEffect, useState } from "react";
import "./style.css";

function RangeSlider({ max = 100, min = 0, value = 0, onChange = () => {}, ...rest }) {
    const [val, setVal] = useState(value);

    useEffect(() => {
        setVal(value);
    }, [value]);

    const numToTime = (wt) => {
        let m = Math.floor(wt / 60);
        let sec = wt % 60;
        return `${(m + "").padStart(2, "0")}:${(sec + "").padStart(2, "0")}`;
    };
    return (
        <>
            <input
                id="custom-range-slider"
                type="range"
                max={max + ""}
                min={min + ""}
                value={val + ""}
                step="any"
                onChange={(e) => {
                    let v = Math.round(e.target.valueAsNumber);
                    setVal(v);
                    onChange(v);
                }}
                {...rest}
            />
            <span id="crs-time">
                {numToTime(val)} / {numToTime(max)}
            </span>
        </>
    );
}

export default RangeSlider;
